import React from 'react'
import Navbar from '../Navbar/Navbar'
import LandingPage from '../Landing/LandingPage'
import styles from "./Header.module.css"

export default function Header() {
  return (
    <div className={styles.ladningbg}>
       <Navbar/>
       <LandingPage/>


    </div>
  )
}
